import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-p-ploygon",
  "use": "icon-p-ploygon-usage",
  "viewBox": "0 0 26 27",
  "content": "<symbol viewBox=\"0 0 26 27\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-p-ploygon\">\n<g id=\"icon-p-ploygon_Frame\">\n<path id=\"icon-p-ploygon_Vector\" d=\"M2.84375 11.0944V23.2519H23.1562V14.8246L11.8227 3.09619L2.84375 11.0944Z\" fill-opacity=\"0.1\" />\n<path id=\"icon-p-ploygon_Vector_2\" d=\"M2.4375 10.9116L11.8438 2.53308L23.5625 14.6605V23.6581H2.4375V10.9116ZM3.25 11.2764V22.8456H22.75V14.9887L11.8016 3.65839L3.25 11.2764Z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol